@import "../../../../../styles/variables";

.eol-result-card {
  &__container {
    border: 1px solid var(--feedback-message-important, #ec8d00);
    box-sizing: border-box;
    background-color: $svs-white;
    margin-bottom: 20px;
    cursor: pointer;
    overflow: hidden;
    text-decoration: none;

    .eol-result-card__link {
      text-decoration: none;
      display: block;
      height: 100%;

      &:focus-visible {
        overflow: hidden;
      }
    }
  }

  &__title {
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
    color: var(--se-alternative-contrast, #333333);
  }

  &__title-content {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
  }

  &__title-standalone-link-inline {
    display: inline;
  }

  &__subtitle {
    color: #333333;
  }

  &__description {
    text-decoration: none;
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    @media (min-width: $uiaas-tablet) {
      -webkit-line-clamp: 2;
      line-clamp: 2;
      word-break: break-word;
    }
  }

  &__replacement-tool {
    margin-top: 16px;
  }

  &__replacement-tool-btn {
    @media (max-width: $uiaas-tablet) {
      width: 100%;
    }
  }

  &__space {
    margin-right: 4px;
  }

  &__text-content-section {
    margin: 16px !important;
  }
}
